import UserTypeOrganization from '../../core/types/Enums/UserTypeOrganization';
import { LantisPageCounterBlModel, UserBlModel, UserRolesBlModel } from '../../../Restful/LantisApi';

export const filterItemsByPermissions = (
    items: Array<LantisPageCounterBlModel>,
    roles: UserRolesBlModel[],
    user: UserBlModel,
) => {
    return items.filter((item) => {
        // eslint-disable-next-line no-prototype-builtins
        if (item.hasOwnProperty('justLantis')) {
            return (item as any).justLantis && user.userTypeOrganizationId === UserTypeOrganization.Lantis;
        }

        if (!item.securityModuleName) return true;

        const roleForItem = roles.find((role) => role.module?.moduleName === item.securityModuleName);
        if (!(item as any).securityMethodName) return Boolean(roleForItem);
        if ((item as any).securityMethodName && !roleForItem) return false;

        const hasPermissionForMethod = roleForItem!.module!.methods!.some(
            (method) => method.methodName === (item as any).securityMethodName,
        );
        return hasPermissionForMethod;
    });
};

export const getCompleteLink = (name: string) => window.location.origin + `/${name}`;
